import React from "react";
import { Card } from "react-bootstrap";
import EmptyList from "go-core/components/EmptyList";
import { Loading } from "go-core/components/Loading";
import { IntercomConversationApi } from "../../../../../../../../services/Api/Admin/adminTypes";
import OrganizationIntercomConversations from "./OrganizationIntercomConversations";

interface Props {
	conversations: IntercomConversationApi[];
	loading: boolean;
}

const SupportTabPreview = ({ conversations, loading }: Props) => {
	return (
		<Card className="subscriptions-card">
			<Card.Body>
				{loading ? (
					<Loading />
				) : conversations.length > 0 ? (
					<OrganizationIntercomConversations conversations={conversations} />
				) : (
					<EmptyList />
				)}
			</Card.Body>
		</Card>
	);
};

export default SupportTabPreview;
